import { CoverageSelectDropdown } from '@/schemas/sceneDataSchema';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { BaseSelectDropdown } from './BaseSelectDropdown';

export const CoverageSelectDropdownFormElement = ({ component }: { component: CoverageSelectDropdown }) => {
  const fieldName = encodeFieldKey(component);

  return (
    <BaseSelectDropdown
      id={fieldName}
      label={component.label}
      options={component.options.map((o) => ({
        value: o.value.toString(),
        label: o.label,
        sublabel: o.sublabel ?? undefined,
      }))}
      error={false}
      helperText={undefined}
      selectProps={{
        value: (component.value as string) ?? '',
      }}
    />
  );
};
